import { render, staticRenderFns } from "./Dinamico.vue?vue&type=template&id=9621c7e6&scoped=true"
import script from "./Dinamico.vue?vue&type=script&lang=js"
export * from "./Dinamico.vue?vue&type=script&lang=js"
import style0 from "./Dinamico.vue?vue&type=style&index=0&id=9621c7e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9621c7e6",
  null
  
)

export default component.exports